import { getProfileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { isProfileAccess } from "@helpers/profileHelper";
import { CLOUDINARY_INTEL_BASE_URL, boltIconTooltipText } from "@utils/enum";
import ReactTooltip from "react-tooltip";

const RedirectSampleProfile = ({ redirectionType = "" }) => {
  const getProfileAccess = isProfileAccess(redirectionType) || {};
  const profileType = getProfileTypeEnum[redirectionType] ?? "";
  const redirectProfile = getProfileAccess?.[profileType];
  const redirectionUrl = getProfileAccess?.redirectionUrl ?? "ports";

  const handleBoltIconClick = (redirectionUrl) => {
    window.open(`/sample-${redirectionUrl}`);
  };

  return !redirectProfile && profileType ? (
    <>
      <a target="_blank" className="cursor-pointer" onClick={() => handleBoltIconClick(redirectionUrl)} id="bolt-icon" data-tip={boltIconTooltipText} style={{ marginLeft: "auto" }}>
        <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} height={"18px"} width={"18px"} />
      </a>
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="bolt-icon" />
    </>
  ) : null;
};

export default RedirectSampleProfile;
